<ng-container *transloco="let t;">

  <app-statistics-view [loading]="loading">

    <div title>
      <h1>
        <span>{{ t('common.labels.resources-list') }}</span>
      </h1>
    </div>

    <div filter>
      <app-resources-filters
        [options]="options"
        (filterSet)="onFilterSet($event)"
      ></app-resources-filters>
    </div>

    <div details>

      <ng-container *ngIf="set === true">
        <app-resources-chart
          [data]="data"
        ></app-resources-chart>

        <div class="p-grid p-mb-2">
          <div class="p-col-6"><h2>{{ t('common.labels.result') }}:</h2></div>
          <div class="p-col-6 p-text-right">
            <button pButton type="button" (click)="onExport()" [label]="t('common.labels.export')" icon="pi pi-file-excel"></button>
          </div>
        </div>

        <app-resources-data
          [data]="data"
        ></app-resources-data>
      </ng-container>

      <ng-container *ngIf="set !== true">
        <p class="p-text-center p-mt-4">
          <fa-icon [icon]="faSlidersH"></fa-icon><br>
          <span [innerHTML]="t('common.labels.set_filter')"></span>
        </p>
      </ng-container>

    </div>

  </app-statistics-view>

</ng-container>
